import { render, staticRenderFns } from "./joinclazzrank.vue?vue&type=template&id=69af2a54&scoped=true&"
import script from "./joinclazzrank.vue?vue&type=script&lang=js&"
export * from "./joinclazzrank.vue?vue&type=script&lang=js&"
import style0 from "./joinclazzrank.vue?vue&type=style&index=0&id=69af2a54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af2a54",
  null
  
)

export default component.exports